import { ShieldCheck, Lock, MapPin } from "lucide-react";

export default function TrustStrip({ compact = false }) {
  const items = [
    { icon: ShieldCheck, label: "RGPD" },
    { icon: Lock, label: "Paiement sécurisé Stripe" },
    { icon: MapPin, label: "Hébergement européen" },
  ];
  return (
    <div className={`flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-muted-foreground ${compact ? "" : "justify-center"}`} data-testid="trust-strip">
      {items.map((it, i) => (
        <div key={i} className="inline-flex items-center gap-1.5">
          <it.icon className="h-3.5 w-3.5 text-primary" />
          <span>{it.label}</span>
        </div>
      ))}
    </div>
  );
}
